jQuery(document).ready(function ($) {
  $(".btn1").on("click", function () {
    $(this).toggleClass("active");
    $(".menu-container").toggleClass("active");
  });
  $(".menu-container a").on("click", function () {
    $(".btn1").removeClass("active");
    $(".menu-container").removeClass("active");
  });

  // .accordion
  let accordionDetails = ".js-details";
  let accordionSummary = ".js-details-summary";
  let accordionContent = ".js-details-content";
  let speed = 500;

  $(accordionSummary).each(function () {
    $(this).on("click", function (event) {
      $(this).toggleClass("is-active");
      event.preventDefault();

      if ($(this).parent($(accordionDetails)).attr("open")) {
        $(this)
          .nextAll($(accordionContent))
          .slideUp(speed, function () {
            $(this).parent($(accordionDetails)).removeAttr("open");
            $(this).show();
          });
      } else {
        $(accordionSummary).not($(this)).removeClass("is-active");
        $(accordionContent)
          .not($(this).nextAll($(accordionContent)))
          .slideUp(speed, function () {
            $(this).parent($(accordionDetails)).removeAttr("open");
            $(this).show();
          });
        $(this).parent($(accordionDetails)).attr("open", "true");
        $(this).nextAll($(accordionContent)).hide().slideDown(speed);
      }
    });
  });
  // /.accordion
});
